import type { TrackEventPayload } from "../types";

export function sendEvent(apiBase: string, publicKey: string, payload: TrackEventPayload): void {
  const url = `${apiBase}/v1/metatag/events?publicKey=${encodeURIComponent(publicKey)}`;
  const body = JSON.stringify(payload);

  // sendBeacon não permite headers customizados, por isso a chave vai na query nesse caminho.
  if (navigator.sendBeacon) {
    const blob = new Blob([body], { type: "application/json" });
    if (navigator.sendBeacon(url, blob)) return;
  }

  void fetch(`${apiBase}/v1/metatag/events`, {
    method: "POST",
    headers: { "Content-Type": "application/json", "x-indexaai-key": publicKey },
    body,
    keepalive: true,
  }).catch(() => {
    // falha de rede não deve afetar a navegação da loja
  });
}
